import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useEffect } from 'react';

import photo from "../Assets/stock/stock1.jpg";
import girl from "../Assets/stock/girl.jpg";
import maldives from "../Assets/stock/maldives.jpg";
import italy from "../Assets/stock/italy.jpg";
import stock2 from "../Assets/stock/stock2.jpg";
import Navbarsec from "./Navbarsec.jsx";
import LoadingScreen from './LoadingScreen.jsx';

const Gallery = () => {
  const [currentItem, setCurrentItem] = useState(1); // Start with the first item
  const totalItems = 5; // Total number of items in the gallery

  useEffect(() => {
    // Automatically switch to the next item every 3 seconds
    const interval = setInterval(() => {
      setCurrentItem((prevItem) => (prevItem % totalItems) + 1);
    }, 3000);

    // Clear the interval when the component unmounts
    return () => clearInterval(interval);
  }, [totalItems]);

  return (
    <div id="gallery" className="relative overflow-hidden rounded-lg md:h-96">
      {/* Use currentItem to conditionally render the active item */}
      <div className={currentItem === 1 ? 'duration-500 ease-in-out' : 'hidden duration-500 ease-in-out'} data-carousel-item={currentItem === 1 ? 'active' : ''}>
        <img src={photo} className="object-contain absolute inline max-w-full h-max -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2" alt="" />
      </div>
      {/* Repeat this pattern for each gallery item */}
      {/* Item 2 */}
      <div className={currentItem === 2 ? 'duration-500 ease-in-out' : 'hidden duration-500 ease-in-out'} data-carousel-item={currentItem === 2 ? 'active' : ''}>
        <img src={girl} className="object-contain absolute inline max-w-full h-max -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2" alt="" />
      </div>
      {/* Item 3 */}
      <div className={currentItem === 3 ? 'duration-500 ease-in-out' : 'hidden duration-500 ease-in-out'} data-carousel-item={currentItem === 3 ? 'active' : ''}>
        <img src={maldives} className="absolute block max-w-full h-auto -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2" alt="" />
      </div>
      {/* Item 4 */}
      <div className={currentItem === 4 ? 'duration-500 ease-in-out' : 'hidden duration-500 ease-in-out'} data-carousel-item={currentItem === 4 ? 'active' : ''}>
        <img src={stock2} className="absolute block max-w-full h-auto -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2" alt="" />
      </div>
      {/* Item 5 */}
      <div className={currentItem === 5 ? 'duration-500 ease-in-out' : 'hidden duration-500 ease-in-out'} data-carousel-item={currentItem === 5 ? 'active' : ''}>
        <img src={italy} className="absolute block max-w-full h-auto -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2" alt="" />
      </div>
    </div>
  );
};

export default function Form() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [tripInfo, setTripInfo] = useState({
    destination: '',
    startDate: '',
    endDate: '',
    totalDays: 0,
    preferences: ''
  });

  const [errors, setErrors] = useState({
    destination: '',
    startDate: '',
    endDate: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTripInfo({ ...tripInfo, [name]: value });
    setErrors({ ...errors, [name]: '' }); // Clear any previous errors when the input changes
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Set loading state to true when form is submitted

    // Validate form inputs
    const { destination, startDate, endDate } = tripInfo;
    const newErrors = {};

    if (!destination.trim()) {
      newErrors.destination = 'Destination is required';
    }

    if (!startDate.trim()) {
      newErrors.startDate = 'Start date is required';
    }

    if (!endDate.trim()) {
      newErrors.endDate = 'End date is required';
    } else if (new Date(endDate) < new Date(startDate)) {
      newErrors.endDate = 'End date cannot be before start date';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setLoading(false); // Set loading state back to false if there are errors
      return; // Stop form submission if there are errors
    }

    // Calculate totalDays using the new function
    const totalDays = calculateTotalDays(startDate, endDate);

    const formData = {
      destination,
      totalDays,
      preferences: tripInfo.preferences
    };

    console.log('Form data:', formData);
    try {
      // Send data to backend
      const response = await axios.post('https://jetsetai-server.vercel.app/api/generate-itinerary', formData);
      console.log('Response from backend:', response.data);
      navigate('/itinerary', { state: { state: response.data } });

      // Optionally, you can reset the form here if needed
      setTripInfo({
        destination: '',
        startDate: '',
        endDate: '',
        totalDays: 0,
        preferences: ''
      });
    } catch (error) {
      console.error('Error sending data to backend:', error);
      // Handle error, display error message to the user, etc.
    } finally {
      setLoading(false); // Set loading state back to false after navigation
    }
  };

  function calculateTotalDays(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const differenceInMilliseconds = end - start;
    const differenceInDays = Math.ceil(
      differenceInMilliseconds / (1000 * 60 * 60 * 24)
    );
    return differenceInDays;
  }

  return (
    <div>
      <Navbarsec />
      <div className="max-w-6xl mx-auto h-full grid grid-cols-1 lg:grid-cols-2 gap-2 lg:gap-1 border border-gray-300 shadow-md p-6 rounded-xl">
        <Gallery />
        <div className="max-w-md mx-auto px-4">
          <form className="space-y-8" onSubmit={handleSubmit}>
            <div className="border-b border-gray-200 pb-8">
              <h2 className="text-lg font-semibold leading-6 text-gray-900">Plan Your Trip </h2>
              <p className="mt-1 text-sm text-gray-600">Share your travel details with us.</p>
              <div className="mt-6">
                <div>
                  <label htmlFor="destination" className="block text-sm font-medium text-gray-700">Destination</label>
                  <input type="text" name="destination" id="destination" className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" placeholder="Enter destination" onChange={handleChange} />
                  {errors.destination && <p className="text-red-500 text-sm mt-1">{errors.destination}</p>}
                </div>
              </div>
              <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-2 sm:gap-x-8">
                <div>
                  <label htmlFor="startDate" className="block text-sm font-medium text-gray-700">Start Date</label>
                  <input type="date" name="startDate" id="startDate" className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" onChange={handleChange} />
                  {errors.startDate && <p className="text-red-500 text-sm mt-1">{errors.startDate}</p>}
                </div>
                <div>
                  <label htmlFor="endDate" className="block text-sm font-medium text-gray-700">End Date</label>
                  <input type="date" name="endDate" id="endDate" className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" onChange={handleChange} />
                  {errors.endDate && <p className="text-red-500 text-sm mt-1">{errors.endDate}</p>}
                </div>
              </div>
              <div className="mt-6">
                <label htmlFor="preferences" className="block text-sm font-medium text-gray-700">Trip Preferences</label>
                <textarea id="preferences" name="preferences" rows={3} className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" placeholder="Outdoor Activities, Dining Experience" onChange={handleChange}></textarea>
              </div>
            </div>
            <div className="pt-5">
              <div className="flex justify-end">
                <button type="submit" className="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                  Generate Itinerary
                </button>
              </div>
            </div>
          </form>
          {loading && <LoadingScreen />}
        </div>
      </div>
    </div>
  );
}
